function deferAction(action) {
  setTimeout(action, 1);
}
var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

export { deferAction, extractRef };
//# sourceMappingURL=util.js.map
